import React from 'react';
import { COLORS } from '../config/constants';

const StatCard = ({ title, value, subtitle, icon, color = COLORS.primary }) => {
  return (
    <div
      data-testid={`stat-card-${title.toLowerCase().replace(/\s/g, '-')}`}
      style={{
        background: COLORS.white,
        borderRadius: '12px',
        padding: '1.5rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        transition: 'transform 0.2s, box-shadow 0.2s',
        cursor: 'pointer',
        borderLeft: `4px solid ${color}`
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.12)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
          <p style={{ color: COLORS.textLight, fontSize: '0.875rem', marginBottom: '0.5rem' }}>
            {title}
          </p>
          <h3 style={{ fontSize: '2rem', fontWeight: '700', color: COLORS.text, margin: 0 }}>
            {value}
          </h3>
          {subtitle && (
            <p style={{ color: COLORS.textLight, fontSize: '0.8rem', marginTop: '0.25rem' }}>
              {subtitle}
            </p>
          )}
        </div>
        {icon && (
          <div
            style={{
              width: '50px',
              height: '50px',
              borderRadius: '10px',
              background: `${color}15`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.5rem'
            }}
          >
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;